import * as React from 'react'
import { useNavigate, useOutletContext, useParams } from 'react-router-dom'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import { isVisible } from 'modules/custom_resources/lib/utils'
import resources from 'modules/custom_resources/store/collections/customResources/resources'
import schemas from 'modules/custom_resources/store/collections/customResources/schemas'
import values from 'modules/custom_resources/store/collections/customResources/values'
import type Field from 'modules/custom_resources/store/models/customResources/Field'
import FormModal from 'modules/employees/components/CustomTables/FormModal'
import { RouteContext } from 'modules/employees/pages/CustomTablesListPage/context'
import type Employee from 'modules/employees/store/models/Employee'

export default function EditCustomTablePage() {
  const { schemaId, valueId } = useParams()

  const { employee, fields } = useOutletContext<{
    employee: Employee
    fields: Field[]
  }>()

  const navigate = useNavigate()
  const rootRoute = React.useContext(RouteContext)
  const schema = schemas.get(Number(schemaId))

  if (!schema) return null

  const resource = resources.find({
    schema_id: schema.attributes.id,
    attachable_type: 'Employee',
    attachable_id: employee.attributes.id,
  })

  const schemaFields = fields.filter(
    (f) =>
      f.get('schema_id') === schema.attributes.id &&
      isVisible(employee, contractVersions)(f.attributes.visible)
  )

  const value = values.get(Number(valueId))

  const onClose = () => {
    !!rootRoute && navigate(rootRoute.customTablesIndex())
  }

  if (!resource) return null

  return (
    <FormModal
      schema={schema}
      fields={schemaFields}
      resource={resource}
      value={value}
      attachableId={employee.attributes.id}
      attachableType="Employee"
      onClose={onClose}
    />
  )
}
